module.exports = __webpack_public_path__ + "static/mobile3-17603ca70be969df412e7b17960e6f30.png";